
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

import Layout from '@/components/layout/Layout';
import Seo from '@/components/Seo';
import { useForm } from 'react-hook-form';
import { Select } from '@/components/forms/Select';
import { getCategories } from '@/lib/repository/machinesRepository';
import { Input } from '@/components/forms/Input';
import { useStoreSellFormStep1 } from '@/lib/hooks/useStore';
import { translateUrl } from '@/lib/server/translateURL';
import { useRouter } from 'next/router';
import machineryImage from '../../../public/sellpage_machine_quartett_900px.png';
import { bingUET } from '@/lib/utilities/analytics/bing';
import { pushDataLayer } from '@/lib/utilities/analytics/gtm';
import { Text } from '@/components/layout/CoorpLayout';
import NewsletterForm from '../../components/forms/NewsLetter/NewsletterForm';
import { ProductAccountManager } from '../../components/product/ProductAccountManager';
import { GetStaticProps } from 'next/types';
import { accountManagers } from '@/lib/data/account-managers';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { getAccountManager } from '@/lib/repository/machinesRepository';
import GoogleReviews from '@/components/visualization/GoogleReviews';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DEFAULT_ACCOUNT_MANAGER } from '@/lib/repository/constants';

export default function SellPage() {
  return (
    <Layout disableNewsletterForm>
      <Seo />
      <main className='bg-white'>
        <Hero />
        <div className='relative z-10 mx-4 -mt-[31rem] mb-12 max-w-[28rem] sm:mx-auto xl:sticky 2xl:top-36  2xl:float-right 2xl:mr-[15%] 2xl:w-1/3'>
          <SellForm />
        </div>
        <div className='mt-24 w-full 2xl:mt-64 child:2xl:pl-[15%] child:2xl:pr-[44%]'>
          <StepsToSell />
          <div className='mt-8 p-4 py-16'>
            <SellingProcess />
          </div>
          <div className='mt-8 bg-[#E9F0F7] p-4 py-16'>
            <PersonalContact />
          </div>
          <div className='mt-8 p-4 pt-16'>
            <CustomerCare />
          </div>
          <div className='mt-8 bg-[#E9F0F7] p-4 py-16'>
            <MachineTypes />
          </div>
          <div className='mt-8 p-4 py-16'>
            <PopularBrands />
          </div>
        </div>
      </main>
      {/* <div className='mt-4 w-full bg-[#E9F0F7] p-4 py-16 child:2xl:pr-[15%] child:2xl:pl-[15%]'>
        <SellMachinery />
      </div> */}
      <NewsletterForm />
      {/* <div className='mt-8 py-16 2xl:pl-[15%] 2xl:pr-[15%]'>
        <SellingOverview />
      </div> */}
    </Layout>
  );
}

function StepsToSell() {
  const { t } = useTranslation('products');
  return (
    <div className='mt-8 bg-slate-100 p-4 py-16'>
      <p className='h2 mb-4 text-center text-2xl uppercase'>
        <strong>{t('products:SELLING_STEP1_STEPS_HEADER')}</strong>{' '}
        {t('products:SELLING_STEP1_STEPS_SUBHEADER')}
      </p>
      <p className='h3 mb-12 text-center'>
        {t('products:SELLING_STEP1_STEPS_SUBTITLE')}
      </p>
      <div className='flex flex-col items-center justify-around space-y-11 md:flex-row md:-space-x-11 md:space-y-0'>
        <div className='flex flex-1 flex-col items-center'>
          <svg viewBox='0 0 151 128' className='icons icon-icons-20' />
          <p className='h3 text-center text-base'>
            {t('products:SELLING_STEP1_STEPS_QUOTE1')}
          </p>
        </div>
        <ArrowRight />
        <div className='flex flex-1 flex-col items-center'>
          <svg viewBox='0 0 106 128' className='icons icon-icons-29' />
          <p className='h3 text-center text-base'>
            {t('products:SELLING_STEP1_STEPS_QUOTE3')}
          </p>
        </div>
        <ArrowRight />
        <div className='flex flex-1 flex-col items-center'>
          <svg viewBox='0 0 198 128' className='icons icon-icons-30' />
          <p className='h3 text-center text-base'>
            {t('products:SELLING_STEP1_STEPS_QUOTE3_2')}
          </p>
        </div>
      </div>
    </div>
  );
}
function ArrowRight() {
  return (
    <div className='hidden h-6 w-28 bg-arrow-right bg-no-repeat md:block' />
  );
}

export interface FormDataStep1 {
  'machine-details_machine_category': string;
  'machine-details_brand': string;
  'machine-details_model': string;
  'machine-details_year': number;
  'machine-details_under_power': '1' | '0';
}

function SellingProcess() {
  const { t } = useTranslation();
  return (
    <>
      <h2 className='mb-12 text-4xl font-bold uppercase text-brand-500'>
        {t('products:SELLING_STEP1_PROCESS_TITLE')}
      </h2>
      <Text isLeft text={t('products:SELLING_STEP1_PROCESS_TEXT')} />
      <div className='mt-8 text-lg'>
        <ul>
          <li className='mt-8'>
            &bull;{' '}
            <p className='h3 inline text-lg font-bold text-brand-500'>
              {t('products:SELLING_STEP1_PROCESS_1_TITLE')}
            </p>{' '}
            {t('products:SELLING_STEP1_PROCESS_1_TEXT')}
          </li>
          <li className='mt-8'>
            &bull;{' '}
            <p className='h3 inline text-lg font-bold text-brand-500'>
              {t('products:SELLING_STEP1_PROCESS_2_TITLE')}
            </p>{' '}
            {t('products:SELLING_STEP1_PROCESS_2_TEXT')}
          </li>
          <li className='mt-8'>
            &bull;{' '}
            <p className='h3 inline text-lg font-bold text-brand-500'>
              {t('products:SELLING_STEP1_PROCESS_3_TITLE')}
            </p>{' '}
            {t('products:SELLING_STEP1_PROCESS_3_TEXT')}
          </li>
          <li className='mt-8'>
            &bull;{' '}
            <p className='h3 inline text-lg font-bold text-brand-500'>
              {t('products:SELLING_STEP1_PROCESS_4_TITLE')}
            </p>{' '}
            {t('products:SELLING_STEP1_PROCESS_4_TEXT')}
          </li>
          <li className='mt-8'>
            &bull;{' '}
            <p className='h3 inline text-lg font-bold text-brand-500'>
              {t('products:SELLING_STEP1_PROCESS_5_TITLE')}
            </p>{' '}
            {t('products:SELLING_STEP1_PROCESS_5_TEXT')}
          </li>
        </ul>
      </div>
    </>
  );
}

function PersonalContact() {
  const isNotXlScreen = useMediaQuery('(max-width: 1536px)');
  const isCentered = isNotXlScreen ? true : false;
  const { t } = useTranslation();

  return (
    <>
      <p className='h2 mb-12 text-center text-4xl font-bold uppercase 2xl:text-left'>
        {t('products:SELLING_STEP1_CONTACT_TITLE')}
      </p>
      <div className='text-left'>
        <ProductAccountManager isCentered={isCentered} sellingPage />
      </div>
    </>
  );
}

function CustomerCare() {
  const { t } = useTranslation();
  return (
    <>
      <p className='h2 mb-12 text-4xl font-bold uppercase'>
        {t('products:SELLING_STEP1_CARE_TITLE')}
      </p>
      <Text isLeft text={t('products:SELLING_STEP1_CARE_TEXT')} />
      <div className='mt-8 text-left'>
        <GoogleReviews />
      </div>
    </>
  );
}

function MachineTypes() {
  const { t } = useTranslation();
  return (
    <>
      <h2 className='mb-12 text-4xl font-bold uppercase'>
        {t('products:SELLING_STEP1_TYPES_TITLE')}
      </h2>
      <Text isLeft text={t('products:SELLING_STEP1_TYPES_TEXT')} />
      <div className='m-auto mt-8 flex w-4/5 flex-wrap justify-around text-center md:text-left 2xl:ml-0 2xl:mr-4 2xl:w-full 2xl:justify-start'>
        <div className='w-full md:w-1/2 lg:mr-8 lg:w-[45%]'>
          <div className='mb-8'>
            <h3>{t('products:SELLING_STEP1_TYPES_MACHINE_TOOLS')}</h3>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SELL_MILLING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Vertical Machining Centre')}</li>
              <li>{t('products:Horizontal Machining Centre')}</li>
              <li>{t('products:CNC Milling Machine')}</li>
              <li>{t('products:Gantry Milling Machine')}</li>
              <li>{t('products:Universal Machining Centre')}</li>
              <li>{t('products:Mill-Turn Centre')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_TURNING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Vertical Turning Machine')}</li>
              <li>{t('products:Horizontal Turning Machine')}</li>
              <li>{t('products:Swiss Type Turning Machine')}</li>
              <li>{t('products:Turn-Mill Centre')}</li>
              <li>{t('products:Multi-Spindle Turning Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_GRINDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Internal Grinding Machine')}</li>
              <li>{t('products:Vertical Grinding Machine')}</li>
              <li>{t('products:Horizontal Grinding Machine')}</li>
              <li>{t('products:Centerless Grinding Machine')}</li>
              <li>{t('products:Surface Grinding Machine')}</li>
              <li>{t('products:Cylindrical Grinding Machine')}</li>
              <li>{t('products:Grinding Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_3D_PRINTERS')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Metal 3D Printer')}</li>
              <li>{t('products:Plastic 3D Printer')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_EDM_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Wire EDM Machine')}</li>
              <li>{t('products:Die-Sinking EDM Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_MEASURING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Coordinate Measuring Machine (CMM)')}</li>
              <li>{t('products:Optical Measurement Machine')}</li>
              <li>{t('products:Laser Measurement Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SAWING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Metal Band Saw')}</li>
              <li>{t('products:Circular Metal Saw')}</li>
              <li>{t('products:Hack Saw')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_BROACHING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Horizontal Broaching Machine')}</li>
              <li>{t('products:Vertical Broaching Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_HONING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Horizontal Honing Machine')}</li>
              <li>{t('products:Vertical Honing Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SHAPING_AND_PLANING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Shaping Machine')}</li>
              <li>{t('products:Planing Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_OTHER_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Drilling Machine (Metal)')}</li>
              <li>{t('products:Boring Machine (Metal)')}</li>
              <li>{t('products:Other Machine Tools')}</li>
            </ul>
          </div>
          <div className='my-8'>
            <h3>
              {t('products:SELLING_STEP1_TYPES_USED_AUTOMATION_EQUIPMENT')}
            </h3>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_ROBOTICS')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Robot Arm')}</li>
              <li>{t('products:Delta Robot')}</li>
              <li>{t('products:Welding Robot')}</li>
              <li>{t('products:Collaborative Robot')}</li>
              <li>{t('products:Gantry Robot')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_OTHER_AUTOMATION_EQUIPMENT')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Automation System')}</li>
              <li>{t('products:Pallet Handling System')}</li>
              <li>{t('products:Work Piece Handling System')}</li>
              <li>{t('products:Other Automation Equipment')}</li>
            </ul>
          </div>
          <div className='mb-8'>
            <h3>
              {t(
                'products:SELLING_STEP1_TYPES_USED_PLASTICS_PROCESSING_MACHINERY'
              )}
            </h3>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_INJECTION_MOULDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Hydraulic Machine')}</li>
              <li>{t('products:Electrical Machine')}</li>
              <li>{t('products:Vertical Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_COMPOUNDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Compounding Extruder')}</li>
              <li>{t('products:Plastics Compounder')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_BLOW_MOULDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Blow Moulding Machines')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_EXTURSION_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Twin Screw Extruder')}</li>
              <li>{t('products:Single Screw Extruder')}</li>
              <li>{t('products:Pipe Extruder')}</li>
              <li>{t('products:Co-Extruder')}</li>
              <li>{t('products:Film Extruder')}</li>
              <li>{t('products:Profile Extruder')}</li>
              <li>{t('products:Sheet Extruder')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t(
                'products:SELLING_STEP1_TYPES_OTHER_PLASTICS_PROCESSING_MACHINERY'
              )}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Pulverizing Machine')}</li>
              <li>{t('products:Calendering Machine')}</li>
              <li>{t('products:Compression Moulding Press')}</li>
              <li>{t('products:Recycling Machine')}</li>
              <li>{t('products:Foam Moulding Machine')}</li>
              <li>{t('products:Rotational Moulding Machine')}</li>
              <li>{t('products:Thermoforming Machine')}</li>
              <li>{t('products:Granulating Machine')}</li>
              <li>{t('products:Other Plastic Processing Machines')}</li>
            </ul>
          </div>
        </div>
        <div className='w-full md:w-1/2 2xl:w-1/2'>
          <div className='mb-8'>
            <h3>
              {t('products:SELLING_STEP1_TYPES_USED_SHEET_METAL_MACHINERY')}
            </h3>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SHEET_METAL_CUTTING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Plasma Cutting Machine')}</li>
              <li>{t('products:Fiber Laser Cutting Machine')}</li>
              <li>{t('products:Waterjet Cutting Machine')}</li>
              <li>{t('products:Tube Cutting Machine')}</li>
              <li>{t('products:CO2 Laser Cutting Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_BENDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Roll Bending Machine')}</li>
              <li>{t('products:Die Bending Machine')}</li>
              <li>{t('products:Press Brake')}</li>
              <li>{t('products:Hydraulic Press')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_PUNCHING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Punch-Laser Combination')}</li>
              <li>{t('products:CNC Punch Press')}</li>
              <li>{t('products:Turret Punch Press')}</li>
              <li>{t('products:CNC Punching Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_STAMPING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Servo Press')}</li>
              <li>{t('products:Hydraulic Stamping Press')}</li>
              <li>{t('products:Mechanical Stamping Press')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_FORMING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Metal Press')}</li>
              <li>{t('products:Deep Drawing Press')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SHEARING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Hydraulic Shearing Machine')}</li>
              <li>{t('products:CNC Shearing Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_ROLLING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Plate Rolling Machine')}</li>
              <li>{t('products:Profile Bending Machine')}</li>
              <li>{t('products:Stretch Forming Machine')}</li>
              <li>{t('products:Angle Rolling Machine')}</li>
              <li>{t('products:Section Rolling Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_OTHER_SHEET_METAL_MACHINERY')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Deburring Machine')}</li>
              <li>{t('products:Edge Rounding Machine')}</li>
              <li>{t('products:Laser Engraving Machine')}</li>
              <li>{t('products:Laser Welding Machine')}</li>
              <li>{t('products:Laser Marking Machine')}</li>
              <li>{t('products:Stamping Machine')}</li>
              <li>{t('products:Other Sheet Metal Machines')}</li>
            </ul>
          </div>
          <div className='mb-8'>
            <h3 className='mb-4'>
              {t('products:SELLING_STEP1_TYPES_USED_WOOD_WORKING_MACHINERY')}
            </h3>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_CNC_WOOD_MACHINE_TOOLS')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:CNC Router')}</li>
              <li>{t('products:CNC Wood Machining Center')}</li>
              <li>{t('products:CNC Processing Center')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t(
                'products:SELLING_STEP1_TYPES_WOOD_BORING_AND_DRILLING_MACHINES'
              )}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Multi-Spindle Drilling Machine')}</li>
              <li>{t('products:Wood Boring Machine')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_PROFILING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Spindle Moulder')}</li>
              <li>{t('products:CNC Profile Grinder')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_WOOD_MILLING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Wood Mill')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_VENEERING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Veneer Guillotine')}</li>
              <li>{t('products:Veneer Splicer')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_PLANING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Wood Planer')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_EDGE_BANDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Edgebander')}</li>
              <li>{t('products:Double Sided Edgebander')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t(
                'products:SELLING_STEP1_TYPES_PRESSING_AND_LAMINATING_MACHINES'
              )}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Veneer Press')}</li>
              <li>{t('products:Laminating Press')}</li>
              <li>{t('products:Briquetting Press')}</li>
              <li>{t('products:Carcase Press')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_WOOD_SAWS')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Circular Wood Saw')}</li>
              <li>{t('products:Mitre Saw')}</li>
              <li>{t('products:Table Saw')}</li>
              <li>{t('products:Wood Band Saw')}</li>
              <li>{t('products:Panel Saw')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_SANDING_MACHINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Belt Sander')}</li>
              <li>{t('products:Drum Sander')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_COMPLETE_PRODUCTION_LINES')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Complete Wood Production Line')}</li>
            </ul>
            <h4 className='mb-4 mt-8 underline'>
              {t('products:SELLING_STEP1_TYPES_OTHER_WOODWORKING_MACHINERY')}
            </h4>
            <ul className='pl-4 md:list-disc'>
              <li>{t('products:Wood Chipper')}</li>
              <li>{t('products:Wood Moulder')}</li>
              <li>{t('products:Wood Shredder')}</li>
              <li>{t('products:Tenoning Machine')}</li>
              <li>{t('products:Other Woodworking Machinery')}</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

function PopularBrands() {
  const { t } = useTranslation();
  return (
    <>
      <h2 className='mb-12 text-4xl font-bold uppercase'>
        {t('products:SELLING_STEP1_POPULAR_TITLE')}
      </h2>
      <Text isLeft text={t('products:SELLING_STEP1_POPULAR_TEXT')} />
      <h3 className='mb-4 mt-8 underline'>
        {t('products:SELLING_STEP1_POPULAR_MACHINE_TOOLS')}
      </h3>
      <ul className='pl-4 md:list-disc'>
        <li>{t('products:SELLING_STEP1_POPULAR_DMG')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_MAZAK')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_HAAS')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_HERMLE')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_OKUMA')}</li>
      </ul>
      <h3 className='mb-4 mt-8 underline'>
        {t('products:SELLING_STEP1_POPULAR_SHEET_METAL_MACHINERY')}
      </h3>
      <ul className='pl-4 md:list-disc'>
        <li>{t('products:SELLING_STEP1_POPULAR_TRUMPF')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_BYSTRONIC')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_AMADA')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_PRIMA')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_LVD')}</li>
      </ul>
      <h3 className='mb-4 mt-8 underline'>
        {t('products:SELLING_STEP1_POPULAR_INJECTION_MOULDING_MACHINERY')}
      </h3>
      <ul className='pl-4 md:list-disc'>
        <li>{t('products:SELLING_STEP1_POPULAR_ENGEL')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_ARBURG')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_KRAUSSMAFFEI')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_FERROMATIK')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_HAITIAN')}</li>
      </ul>
      <h3 className='mb-4 mt-8 underline'>
        {t('products:SELLING_STEP1_POPULAR_ROBOTICS')}
      </h3>
      <ul className='pl-4 md:list-disc'>
        <li>{t('products:SELLING_STEP1_POPULAR_KUKA')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_ABB')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_YASKAWA')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_KAWASAKI')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_FANUC')}</li>
      </ul>
      <h3 className='mb-4 mt-8 underline'>
        {t('products:SELLING_STEP1_POPULAR_WOOD_WORKING_MACHINERY')}
      </h3>
      <ul className='pl-4 md:list-disc'>
        <li>{t('products:SELLING_STEP1_POPULAR_HOMAG')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_BIESSE')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_SCM')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_WEEKE')}</li>
        <li>{t('products:SELLING_STEP1_POPULAR_IMA')}</li>
      </ul>
    </>
  );
}

// function SellMachinery() {
//   const { t } = useTranslation();
//   return (
//     <>
//       <h2 className='mb-12 text-4xl uppercase font-bold'>
//           {t('products:SELLING_STEP1_SELL_TITLE')}
//       </h2>
//       <Text isLeft text={t('products:SELLING_STEP1_SELL_TEXT1')} />
//       <Text isLeft text={t('products:SELLING_STEP1_SELL_TEXT2')} />
//       <div className='mt-8 flex flex-col lg:flex-row'>
//         <div className='px-12 lg:w-1/2'>
//           <button
//             type='button'
//             className='mb-4 w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON1')}
//           </button>
//           <button
//             type='button'
//             className='mb-4 w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON2')}
//           </button>
//           <button
//             type='button'
//             className='w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON3')}
//           </button>
//         </div>
//         <div className='px-12 pt-4 lg:w-1/2 lg:pt-0'>
//           <button
//             type='button'
//             className='mb-4 w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON4')}
//           </button>
//           <button
//             type='button'
//             className='mb-4 w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON5')}
//           </button>
//           <button
//             type='button'
//             className='mb-4 w-full rounded-3xl border-4 border-secondary-800 bg-white py-6 text-xl font-bold uppercase text-secondary-800 hover:bg-secondary-800 hover:text-white'
//             disabled
//           >
//             {t('products:SELLING_STEP1_SELL_BUTTON6')}
//           </button>
//         </div>
//       </div>
//       <Text isLeft text={t('products:SELLING_STEP1_SELL_TEXT3')} />
//     </>
//   );
// }

function SellForm() {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormDataStep1>({
    mode: 'onBlur',
  });
  const router = useRouter();
  const [_sellFormStep1, setForm] = useStoreSellFormStep1();
  function submit(data: FormDataStep1) {
    setForm(data);
    const url = translateUrl(
      '/selling-process/step-2',
      router.locale ?? 'en-US'
    );
    pushDataLayer('formSubmission', {
      formType: 'Sell Step 1',
      locale: router?.locale,
    });
    bingUET('Sell Step 1');
    router.push(url);
  }

  return (
    <>
      <div className='bg-white 2xl:border-2 2xl:shadow-xl'>
        <div className='flex items-center justify-center bg-secondary-800 py-8'>
          <h2 className='text-center text-[1.25rem] text-brand-500'>
            {t('products:SELLING_STEP1_FORM_HEADER')}
          </h2>
        </div>
        <div className='mt-4 flex items-center space-x-4 p-4'>
          <div className='h-px flex-grow bg-black' />
          <p className='h3 text-center text-base font-normal uppercase text-black'>
            {t('products:SELLING_STEP1_FORM_LOCATION')}
          </p>
          <div className='h-px flex-grow bg-black' />
        </div>
        <form className='space-y-4 p-4' onSubmit={handleSubmit(submit)}>
          <Select
            label={t('products:FORM_SELECT_CATEGORY')}
            options={getCategories().map((category) => ({
              value: category.name,
              label: t(
                'products:' + category.name,
                {},
                {
                  default: category.name,
                }
              ),
            }))}
            errors={errors}
            register={register}
            name='machine-details_machine_category'
            validation={{ required: true }}
          />
          <Input
            placeholder={t('products:FORM_PLACEHOLDER_BRAND')}
            errors={errors}
            register={register}
            name='machine-details_brand'
            validation={{ required: true }}
          />
          <Input
            placeholder={t('products:FORM_PLACEHOLDER_MODEL')}
            errors={errors}
            register={register}
            name='machine-details_model'
            validation={{ required: true }}
          />
          <Input
            type='number'
            placeholder={t('products:FORM_PLACEHOLDER_YEAR')}
            errors={errors}
            register={register}
            name='machine-details_year'
            validation={{
              min: 1900,
              max: new Date().getFullYear(),
              required: true,
            }}
          />
          <Select
            label={t('products:FORM_MACHINE_UNDER_POWER')}
            name='machine-details_under_power'
            options={[
              { value: '1', label: t('products:Yes') },
              { value: '0', label: t('products:No') },
            ]}
            errors={errors}
            register={register}
            validation={{ required: true }}
          />
          <button
            type='submit'
            className='mt-4 w-full rounded bg-secondary-500 py-4 uppercase text-brand-500'
            data-testid='submit-step-1'
            disabled={isSubmitting}
          >
            {t('products:SELLING_STEP1_FORM_BTN_SUMBIT')}
          </button>
        </form>
        <div className='mt mt-4 bg-[#F4F8Fd] p-[0.9rem] text-center text-sm text-brand-500'>
          <p className='pb-2 font-bold'>
            {t('products:SELLING_STEP1_FORM_MSG1')}
          </p>
          <p>
            {t('products:SELLING_STEP1_FORM_MSG2')}{' '}
            <span className='font-bold'>
              {t('products:SELLING_STEP1_FORM_MSG3')}
            </span>{' '}
            {t('products:SELLING_STEP1_FORM_MSG4')}
          </p>
        </div>
      </div>
    </>
  );
}

function Hero() {
  const { t } = useTranslation();
  return (
    <>
      <div className='relative h-[35rem] w-full bg-black'>
        <Image
          src='/images/home/bg-hero.webp'
          alt='Industrial Machinery Background'
          fill
          sizes='(min-width: 1880px) 100vw, 1773px'
          className='z-0 object-cover object-center'
          priority={true}
        />
        <div className='z-100 absolute inset-0 bg-[#0F3970] bg-opacity-50' />
        <div className='2xl:left-1/5 absolute left-44 top-[12rem] hidden h-[20rem] w-[45%] text-white 2xl:bottom-[8rem] 2xl:top-auto 2xl:block'>
          <h1 className='mb-12 text-4xl font-bold uppercase text-white'>
            {t('products:SELLING_STEP1_HEADER_TITLE')}
          </h1>
          <p className='w-[42rem] text-lg'>
            <span className='font-bold'>
              {t('products:SELLING_STEP1_HEADER_TEXT1')}
            </span>{' '}
            {t('products:SELLING_STEP1_HEADER_TEXT2')}{' '}
            <span className='font-bold'>
              {t('products:SELLING_STEP1_HEADER_TEXT3')}
            </span>
            {t('products:SELLING_STEP1_HEADER_TEXT4')}
          </p>
          <Image
            src={machineryImage}
            alt='Example Machinery'
            className='z-10 object-contain object-bottom'
            priority={true}
          />
        </div>
      </div>
    </>
  );
}

 const _getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();
  try {
    await queryClient.fetchQuery(
      ['account_manager', locale, null],
      () => {
        try {
          return getAccountManager(locale ?? 'en-GB');
        } catch (error) {
          const am = accountManagers.find((am) =>
            am.locales ? am.locales.includes((locale ?? '') as never) : false
          );
          return am ?? DEFAULT_ACCOUNT_MANAGER;
        }
      },
      {
        retry: 8,
      }
    );

    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
    };
  } catch (error) {
    console.error(error);
    return {
      props: {},
    };
  }
};


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/selling-process/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  